import {getAutocompleteState} from '../state/autocompleteState'
import {emitAutocompleteValue} from "./globalizeValues"

function setSelected(type: string, id: string, label: string, store: any): void {
    const selectedItem = { type, id, label }
    store.data.selected.autocompleteValue = selectedItem
    emitAutocompleteValue(selectedItem)
    getAutocompleteState().state.showTopStations = true
}

export default setSelected
